import { DefaultI18nValues } from './types';

export const defaultI18nEn: DefaultI18nValues = {
	'general.ok': 'Ok',
	'simulator.modals.genericError.title': 'Oops, we couldn`t process your request.',
	'simulator.modals.genericError.pleaseTryAgain': 'Please try again.',
	'simulator.modals.genericError.exit': 'Exit',
};
